import { ROUTES } from '@/utils/constants';
import { removeProductFromUid } from '@/utils/url/url';

/**
 * Hub-style routes (Epic Hub, Influencer Hub, Gameplay Session) all carry a slug
 * with a product prefix (e.g. `casino-roulette`). The aggregation `getPageConfig`
 * expects a plain category route without the hub segment or product prefix
 * (e.g. `/c/roulette`), so any of these is mapped to `/c/<slug-without-product>`.
 *
 * Livestream has a fixed public route but is configured as the `livestream`
 * category in the CMS, so it maps to `/c/livestream`.
 *
 * Other routes are returned unchanged.
 */
const HUB_ROUTE_PREFIXES = [ROUTES.CATEGORY_HUB, ROUTES.INFLUENCER_HUB, ROUTES.GAMEPLAY_SESSION];

export const normalizeRouteForPageConfig = (route: string): string => {
    if (route === ROUTES.LIVESTREAM) {
        return `${ROUTES.CATEGORY}livestream`;
    }

    const matchedPrefix = HUB_ROUTE_PREFIXES.find((prefix) => route.startsWith(prefix));
    if (!matchedPrefix) {
        return route;
    }
    const slug = route.slice(matchedPrefix.length);
    return `${ROUTES.CATEGORY}${removeProductFromUid(slug)}`;
};
